import { ISummaryStory } from 'store/ticket-service/types';

export const getSortedSummary = (summary: any) => {
	let sortTypes: string[] = [];
	let filteredArray: any[] = [];

	if (!summary || summary.length === 0) {
		return [];
	}

	summary.forEach((item: string | ISummaryStory) => {
		const splittedArray =
			typeof item === 'string' ? item.trim().split(' ') : item.data.trim().split(' ');
		const itemType = `${splittedArray[0]} ${splittedArray[1]} ${splittedArray[2]}`;
		if (!sortTypes.includes(itemType)) sortTypes = [...sortTypes, itemType];
	});

	sortTypes.forEach((type) => {
		filteredArray = [
			...filteredArray,
			...summary.filter((item: string | ISummaryStory) => {
				if (!filteredArray.find((element) => element === item)) {
					return typeof item === 'string' ? item.includes(type) : item.data.includes(type);
				}
				return false;
			}),
		];
	});
	return filteredArray;
};
